export default __webpack_public_path__ + "static/media/guru-1.75d6d7de.png";